<template>
  <v-autocomplete
    prepend-inner-icon="mdi-magnify"
    v-model="select"
    :loading="loading"
    :items="items"
    :search-input.sync="search"
    :filter="filterObject"
    item-text="apellido_y_nombre"
    item-value="id_afiliado"
    class="mx-4"
    flat
    hide-no-data
    hide-details
    label="Nombre | DNI | Nro.Afiliado | CUIL"
    outlined
    dense
    return-object
    no-filter
    @change="selected"
  >
    <template v-slot:item="data">
      <v-list-item-content
        :class="{
          deAlta:
            data.item.fecha_fin_cobertura == null ||
            data.item.fecha_fin_cobertura >= hoy,
          deBaja:
            data.item.fecha_fin_cobertura != null &&
            data.item.fecha_fin_cobertura < hoy
        }"
      >
        <v-list-item-title
          v-html="data.item.apellido_y_nombre"
        ></v-list-item-title>
        <v-list-item-subtitle
          >{{ data.item.nro_afi }}/{{ data.item.parent }} - cuil:
          {{ data.item.cuil }}</v-list-item-subtitle
        >
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import API from '@/lib/API'
import LUM from '../../lib/LUM'
import { debounce } from '../../lib/debounce'
export default {
  props: {
  },
  data() {
    return {
      loading: false,
      items: [],
      search: null,
      select: null,
      seleccionado: false
    }
  },
  created() {
    this.debouncedFetch = debounce((newValue, oldValue) => {
      if (newValue && newValue.length > 2) {
        if (!this.seleccionado) {
          newValue = newValue.replace('/', '__')
          this.querySelections(newValue)
        } else {
          this.seleccionado = false
        }
      }
    }, 500)
  },
  computed: {
    hoy() {
      return LUM.datetoYYYYMMDD(new Date())
    }
  },
  watch: {
    search(val) {
      this.debouncedFetch(val)
      // if (val) {
      //   if (!this.seleccionado) {
      //     val = val.replace("/", "__");
      //     this.querySelections(val);
      //   } else {
      //     this.seleccionado = false;
      //   }
      // }
    },
    select() {
      if (this.select) {
        this.$emit('input', this.select)
      } else {
        this.$emit('input', undefined)
      }
    }
  },
  methods: {
    querySelections(v) {
      this.loading = true
      API.Beneficiarios.BuscarNombreNroDNIOspical(v).then((data) => {
        this.loading = false
        let lista = []
        this.items = data
      })
    },
    selected() {
      this.seleccionado = true
    },
    filterObject(item, queryText, itemText) {
      return (
        item.apellido_y_nombre
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.nro_doc.toString().indexOf(queryText) > -1
      )
    }
  }
}
</script>
<style>
.deAlta {
  color: green !important;
}
.deBaja {
  color: red !important;
}
</style>
